import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      position="top-center"
      richColors
      duration={4000}
      style={{ zIndex: 9999 }}
      toastOptions={{
        style: {
          zIndex: 9999,
        },
        classNames: {
          toast: "bg-white text-gray-900 border border-gray-200 shadow-lg",
          error: "!bg-red-50 !text-red-900 !border-red-300",
          success: "!bg-green-50 !text-green-900 !border-green-300",
          warning: "!bg-yellow-50 !text-yellow-900 !border-yellow-300",
          info: "!bg-blue-50 !text-blue-900 !border-blue-300",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
